import {
  AutoComplete,
  Button,
  Checkbox,
  Collapse,
  Form,
  Input,
  Spin,
  TreeSelect,
} from "antd";
import React, { useContext, useState, useEffect } from "react";
import { NomenclatureContext } from "../../lib/hooks/context/getNomenclatureContext";
import { useForm } from "antd/es/form/Form";
import { useSearchParams } from "react-router-dom";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const FilterNomenclature = ({ isOpen }) => {
  const { token, categoriesData } = useContext(NomenclatureContext);
  const [optionsCategories, setOptionsCategories] = useState([]);
  const [globalCategoriesTree, setGlobalCategoriesTree] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setLoading] = useState(false);
  const [form] = useForm();

  // Загрузка дерева глобальных категорий
  useEffect(() => {
    const loadGlobalCategoriesTree = async () => {
      try {
        const res = await fetch(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/mp/categories/tree-select/`,
        );
        const data = await res.json();
        if (data?.result) {
          setGlobalCategoriesTree(data.result);
        }
      } catch (err) {
        console.error("Ошибка загрузки дерева глобальных категорий:", err);
      }
    };
    if (isOpen) {
      loadGlobalCategoriesTree();
    }
  }, [isOpen]);

  const searchHandler = async (values) => {
    // Обработка фильтров
    const processedValues = { ...values };
    for (let key in processedValues) {
      if (key === "category") {
        if (processedValues[key]?.length > 0) {
          const category = optionsCategories.find((i) => i.value === processedValues[key]);
          if (category) {
            processedValues[key] = category.key;
          }
        }
      }
      // has_photos остается как есть - это параметр для фильтрации на бэкенде
      // with_photos используется только для включения фото в ответ
      if (!processedValues[key] && processedValues[key] !== 0) {
        delete processedValues[key];
      }
    }
    setLoading(true);
    
    // Обновляем searchParams - это автоматически вызовет useEffect в TableNomenclature
    setSearchParams({
      token,
      limit: 10,
      offset: 0,
      ...processedValues,
    });
    
    setLoading(false);
  };

  const getData = async () => {
    setOptionsCategories(
      [...categoriesData].map((i) => ({
        value: i.name,
        label: i.name,
        key: i.id,
      }))
    );
  };

  // При открытии фильтров подготавливаем данные и заполняем форму из searchParams
  useEffect(() => {
    if (!isOpen) return;

    const prepare = async () => {
      await getData();
        searchParams.forEach((value, name) => {
          if (name === "category") {
            // eslint-disable-next-line
            const category = categoriesData.find((i) => i.id == value);
            if (category) {
              form.setFieldValue(name, category.name);
            }
          } else if (name === "has_photos" || name === "with_photos") {
            form.setFieldValue("has_photos", value === "true" || value === true);
          } else if (name === "global_category_id") {
            form.setFieldValue(name, Number(value));
          } else if (name === "chatting_percent") {
            form.setFieldValue(name, Number(value));
          } else {
          !Number(value)
            ? form.setFieldValue(name, value)
            : form.setFieldValue(name, Number(value));
          }
      });
  };

    prepare();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const resetFields = () => {
    form.resetFields();
    
    // Обновляем searchParams - это автоматически вызовет useEffect в TableNomenclature
    setSearchParams({
      token,
      limit: 10,
      offset: 0,
    });
  };

  return (
    <Collapse
      className="nomenclature-filter-collapse"
      activeKey={isOpen ? ["1"] : []}
      ghost
      style={{ margin: "2px 0 0 0", width: "100%" }}
    >
      <Panel header={null} key="1" showArrow={false} style={{ paddingLeft: 0 }}>
        <Form
          layout={"inline"}
          style={{
            width: "100%",
            marginBottom: "15px",
            rowGap: "15px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            pointerEvents: `${isLoading === true ? "none" : ""}`,
          }}
          form={form}
          onFinish={searchHandler}
        >
          <Form.Item name={"name"} label="Название">
            <Input placeholder="название" />
          </Form.Item>
          <Form.Item name={"description_long"} label="Описание">
            <Input placeholder="описание" />
          </Form.Item>
          <Form.Item name={"category"} label="Категория товара">
            <AutoComplete
              style={{ minWidth: "200px" }}
              options={optionsCategories}
              allowClear
            ></AutoComplete>
          </Form.Item>
          <Form.Item name={"global_category_id"} label="Глобальная категория">
            <TreeSelect
              style={{ minWidth: "200px" }}
              treeData={globalCategoriesTree}
              placeholder="Выберите глобальную категорию"
              treeDefaultExpandAll={false}
              showSearch
              allowClear
              treeLine
              filterTreeNode={(input, node) =>
                (node?.title || "").toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
          <Form.Item
            name={"has_photos"}
            label="Наличие фото"
            valuePropName="checked"
          >
            <Checkbox>Только с фото</Checkbox>
          </Form.Item>
          <Form.Item name={"chatting_percent"} label="Комиссия платформы">
            <Input
              type="number"
              placeholder="%"
              style={{ width: 120 }}
              addonAfter="%"
            />
          </Form.Item>
          <Button
            icon={<DeleteOutlined />}
            danger={true}
            onClick={resetFields}
            style={{ marginRight: "6px" }}
          >
            Очистить
          </Button>
          <Form.Item>
            <Button
              style={
                isLoading === true
                  ? { display: "flex", alignItems: "center", gridGap: "8px" }
                  : null
              }
              icon={isLoading === true ? null : <SearchOutlined />}
              htmlType={"submit"}
            >
              {isLoading === true ? <Spin size={"small"} /> : null}
              Поиск
            </Button>
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default FilterNomenclature;
